module.exports = __webpack_public_path__ + "img/OMillionaire_logo_Final.2e91aa18.svg";